import React from "react";
import { cn } from "../lib/utils";

export const NumberInput = ({ label, value, onChange, testId, placeholder = "0", suffix = "€" }) => {
  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      onChange(0);
      return;
    }
    const num = Number(raw);
    if (!isNaN(num) && num >= 0) onChange(num);
  };

  return (
    <label className="flex flex-col gap-1.5 group">
      <span className="text-sm font-medium text-slate-700">{label}</span>
      <div className="relative">
        <input
          data-testid={testId}
          type="number"
          min="0"
          step="0.01"
          inputMode="decimal"
          value={value === 0 ? "" : value}
          placeholder={placeholder}
          onChange={handleChange}
          className={cn(
            "w-full bg-white/70 border border-slate-200 text-indigo-950 placeholder:text-slate-300",
            "rounded-xl px-4 py-2.5 text-base font-medium tracking-tight",
            "focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none",
            "transition-all duration-200 group-hover:border-slate-300"
          )}
          style={{ fontFamily: "Outfit, sans-serif" }}
        />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-slate-400 pointer-events-none">
          {suffix}
        </span>
      </div>
    </label>
  );
};

export const TextInput = ({ label, value, onChange, testId, type = "text", placeholder = "" }) => (
  <label className="flex flex-col gap-1.5">
    <span className="text-sm font-medium text-slate-700">{label}</span>
    <input
      data-testid={testId}
      type={type}
      value={value || ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-white/70 border border-slate-200 text-indigo-950 placeholder:text-slate-300 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none transition-all duration-200"
    />
  </label>
);

export const SelectInput = ({ label, value, onChange, options, testId, placeholder = "—" }) => (
  <label className="flex flex-col gap-1.5">
    <span className="text-sm font-medium text-slate-700">{label}</span>
    <select
      data-testid={testId}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-white/70 border border-slate-200 text-indigo-950 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none transition-all"
    >
      <option value="">{placeholder}</option>
      {options.map(({ value: v, label: l }) => (
        <option key={v} value={v}>
          {l}
        </option>
      ))}
    </select>
  </label>
);
